import React from "react";
import PropTypes from "prop-types";
import Modal from "../Modal/Modal";
import Loading from "../Loading/Loading";


const ModalProcessingTwoFactorAuthentication = ({ show, onConfirm }) => (
	<div className="modal-processing-two-factor-authentication">
		<Modal
			title="Processando a oferta..."
			description={<Loading fillColor="#6ECB52" width={60} height={60} />}
			show={show}
			onConfirm={onConfirm}
			fixed={true}
			width={320}
			height={178}
			dontUseDefaultOption={true}
		/>
	</div>

);

ModalProcessingTwoFactorAuthentication.propTypes = {
	show: PropTypes.bool.isRequired,
	onConfirm: PropTypes.func
};

export default ModalProcessingTwoFactorAuthentication;
